import { BuildingOfficeOrderSiteMenuList } from "../../utils/constants";
import { TableStructure } from "../../components/TableStructure";

const List = [
  {
    fileStoreId: "600d8240-29b5-4e9c-9ea0-6c175a757dd3",
    label: "DG(BLDG)'s Office Order No. 21 of 2012-2013",
    date: "20/12/2012",
    subject: "Observation to be written in Special Commemt in MBC agenda",
  },
  {
    fileStoreId: "d3649504-443b-43be-874a-1b012b7a4d49",
    label: "DG(BLDG)'s Office Order No. 20 of 2012-2013",
    date: "12/12/2012",
    subject: "Minor deviation with 400 fees",
  },
  {
    fileStoreId: "94408d61-3330-4dfc-a738-fd9193d74f78",
    label: "DG(BLDG)'s Office Order No. 19 of 2012-2013",
    date: "31/12/2012",
    subject: "Disposal of pending plan cases",
  },
  {
    fileStoreId: "1ceb6afd-f9ea-4787-96cd-f3a9b2f2e51f",
    label: "DG(BLDG)'s Office Order No. 19 of 2012-2013",
    date: "25/09/2012",
    subject: "Inspection of construction site for dengu malaria",
  },
  {
    fileStoreId: "e33f4582-a79b-435f-b6c2-9b680927ac31",
    label: "DG(BLDG)'s Office Order No. 18 of 2012-2013",
    date: "12/09/2012",
    subject: "Site inspection date and time",
  },
  {
    fileStoreId: "ea65505e-a712-4989-bf9f-e727ecf2a9fd",
    label: "DG(BLDG)'s Office Order No. 16 of 2012-2013",
    date: "18/08/2012",
    subject: "Encroachment problem on the banks of drainage canals",
  },
  {
    fileStoreId: "49a6d78f-0802-47f0-844d-1ef25f29adbd",
    label: "DG(BLDG)'s Office Order No. 15 of 2012-2013",
    date: "08/08/2012",
    subject: "Guidelint to deal plan cases under Rule 142",
  },
  {
    fileStoreId: "6c736bcf-6be6-4a5f-91da-a51f6a2783fa",
    label: "DG(BLDG)'s Office Order No. 09 of 2012-2013",
    date: "15/06/2012",
    subject: "No outstanding certificate from assessment dept",
  },
  {
    fileStoreId: "f1bf7e80-936f-49a2-8c43-387eb2c91a00",
    label: "DG(BLDG)'s Office Order No. 08 of 2012-2013",
    date: "06/06/2012",
    subject: "Updated NOC from Assessment Department",
  },
  {
    fileStoreId: "2fc5ea25-0258-4feb-b754-7e6ed11d212f",
    label: "DG(BLDG)'s Office Order No. 07 of 2012-2013",
    date: "05/06/2012",
    subject: "To prepare Computarized list of insecure building",
  },
];

const Building_OfficeOreder_2012 = () => (
  <TableStructure
    title="Office Order/ 2012"
    heading={false}
    list={List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Building_OfficeOreder_2012;
